/**
 * Splash store - coordinates the native splash handoff with the animated "Stomp" splash.
 *
 * Flow: native splash stays up until auth resolves (AppContentWrapper) → markNativeSplashHidden()
 * → AnimatedSplash starts its timeline → on completion markAnimationComplete() → host unmounts.
 * Kept in a global store (no provider) so the producer (layout) and consumer (splash host) stay decoupled.
 */

import { create } from 'zustand';

interface SplashStoreState {
  nativeSplashHidden: boolean;
  animationComplete: boolean;
  markNativeSplashHidden: () => void;
  markAnimationComplete: () => void;
}

export const useSplashStore = create<SplashStoreState>((set) => ({
  nativeSplashHidden: false,
  animationComplete: false,
  markNativeSplashHidden: () => set({ nativeSplashHidden: true }),
  markAnimationComplete: () => set({ animationComplete: true }),
}));
